export class InternalUseSSRComputationError extends Error {
    constructor(message, result) {
        super(message);
        this.name = 'InternalUseSSRComputationError';
        this.result = result;
    }
}
export class UseSSRComputationError extends Error {
    constructor(message, dependencies, ssrComputationFile, error, partialResult) {
        super(message);
        this.name = 'UseSSRComputationError';
        this.dependencies = dependencies;
        this.error = error;
        this.result = partialResult;
        this.ssrComputationFile = ssrComputationFile;
    }
}
let errorHandler = () => { };
export const setErrorHandler = (handler) => {
    errorHandler = handler;
};
export const handleError = (error) => {
    if (typeof errorHandler === 'function') {
        errorHandler(error);
    }
    else {
        console.error(error);
    }
};
export const wrapErrorHandler = (useSSRComputation) => {
    return (...args) => {
        try {
            return useSSRComputation(...args);
        }
        catch (error) {
            let message = '';
            let result = null;
            if (error instanceof InternalUseSSRComputationError) {
                message = error.message;
                result = error.result;
            }
            else {
                message = String(error);
            }
            const [_, dependencies, __, relativePathToCwd] = args;
            const useSSRComputationError = new UseSSRComputationError(message, dependencies, relativePathToCwd, error, result);
            handleError(useSSRComputationError);
            return result;
        }
    };
};
